import React from 'react';
import backgroundImg from '../../../assets/images/about_screen/bgPhilosphi.webp';
import childImg from '../../../assets/images/about_screen/aboutBoy.png';
import cartoon from '../../../assets/images/about_screen/cartoon.png';
import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';

const PhilosophySection = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat flex"
      style={{
        backgroundImage: `url(${backgroundImg})`,
      }}
    >
      <div className="w-full flex flex-col justify-between gap-10 max-w-[1300px] mx-auto px-4 sm:px-8 pt-0 relative z-10 md:h-[2000px]">
        <div className="h-auto md:max-w-[450px] lg:max-w-[500px] 3xl:max-w-[650px] bg-[#2D2C83]/80 text-white rounded-bl-[40px] rounded-br-[40px]">
          <div className="relative px-6 xs:px-12 lg:px-[40px] 3xl:px-[45px] pb-10 2xl:pb-12 3xl:pb-16 pt-20 2xl:pt-24 3xl:pt-40">
            <div className="absolute top-2 sm:top-4 -right-0 md:-right-5 lg:-right-8 xl:-right-12">
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1, ease: 'easeInOut' }}
                viewport={{ once: true, amount: 0.5 }}
              >
                <img
                  src={cartoon}
                  alt="cartoon icon"
                  className="w-[140px] md:w-[160px] lg:w-[140px] 2xl:w-[200px] 3xl:w-[250px]"
                />
              </motion.div>
            </div>
            <p className="uppercase md:text-lg xl:text-[28px] tracking-widest text-white/70 mb-4">
              O u r &nbsp; P h i l o s o p h y
            </p>
            <h2 className="text-4xl lg:text-[52px] 2xl:text-[60px] 3xl:text-[72px] text-white font-bold md:leading-[50px] xl:leading-[55px] 2xl:leading-[80px] mb-4 sm:mb-6">
              The Art of <br /> Looking Forward
            </h2>
            <p className="text-[20px] lg:text-[24px] 3xl:text-[30px] leading-[36px] 3xl:leading-[44px]">
              Guidepost Pediatrics was built out of passion for early childhood
              education and intervention. At Guidepost Pediatric, we love the
              Art of Looking Forward. Even in today’s instant, digital, fast
              paced therapy environment, we are inextricably linked to the
              timeless values of careful evaluation and professional execution
              of therapy plans. But to have a say in the future, one must know
              how to do what is right in the present.
            </p>
            <p className="text-[20px] lg:text-[24px] 3xl:text-[30px] leading-[36px] 3xl:leading-[44px]">
              <br />
              To do what is right is the product of great effort, vigilance and
              discipline. Time and time again, in our experience in our
              respective fields of practice, doing what is right is something
              that cannot be bought. Integrity combined with experience has
              proven to be the very essence of success. We take that
              responsibility seriously in the treatment of your child and
              guidance for your family.
            </p>
          </div>
        </div>
        <div className="md:absolute bottom-0 md:right-20 2xl:right-10 z-20">
          <motion.div
            initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <img
              src={childImg}
              alt="Child achieving therapy goal in Wasilla, Alaska"
              className="mx-auto w-[70vw] md:w-[580px] object-contain object-center"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PhilosophySection;
